import React, { FC, useCallback } from 'react';
import Button from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Button';
import { Home } from '@johnlewispartnership/wtr-ingredients/dist/foundations/icons';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { logger } from 'logger';
import config from 'config';
import { navigateTo } from 'utils/location';

import styles from './ReturnToAdmin.module.scss';

export const ReturnToAdmin: FC = () => {
  const { state: authState, logout } = useAuthentication();
  const returnToAdminUrl = `${config.adminAppUrl}/customer/${authState.customerId}/details`;

  const handleReturnToAdmin = useCallback(async () => {
    try {
      await logout('/');
      navigateTo(returnToAdminUrl);
    } catch (error) {
      logger.error({
        payload: {
          message: `Return to admin error: ${(error as Error).message}`,
        },
      });
    }
  }, [logout, returnToAdminUrl]);

  return authState.isSignedOnAsCustomer ? (
    <div className={styles.returnToAdmin}>
      <Button
        startIcon={<Home />}
        label="Return to admin"
        onClick={handleReturnToAdmin}
        width="fit"
      />
    </div>
  ) : null;
};
